import { FieldLabel } from '../../../shared/ui/field-label';
import { Input } from '../../../shared/ui/input';
import { Textarea } from '../../../shared/ui/textarea';
import type { ISampleDraft } from '../model';
import { TakeFromStream } from './take-from-stream';

interface ISampleEditorProps {
  value: ISampleDraft;
  onChange: (next: ISampleDraft) => void;
}

export const SampleEditor = ({ value, onChange }: ISampleEditorProps) => {
  const set = (patch: Partial<ISampleDraft>) => onChange({ ...value, ...patch });

  return (
    <div className="flex flex-col gap-3">
      <TakeFromStream onTake={onChange} />
      <div>
        <FieldLabel htmlFor="sample-headers">Headers, one per line</FieldLabel>
        <Textarea
          id="sample-headers"
          mono
          rows={4}
          spellCheck={false}
          placeholder={'Stripe-Signature: t=1758114127,v1=5f3c9a…\nContent-Type: application/json'}
          value={value.headersText}
          onChange={(event) => set({ headersText: event.target.value })}
        />
      </div>

      <div>
        <FieldLabel htmlFor="sample-body">Body, exactly as it arrived</FieldLabel>
        <Textarea
          id="sample-body"
          mono
          rows={4}
          spellCheck={false}
          placeholder='{"id":"in_1Qk8Xz","object":"invoice"}'
          value={value.body}
          onChange={(event) => set({ body: event.target.value })}
        />
      </div>

      <div className="flex gap-3">
        <div className="w-col-try shrink-0">
          <FieldLabel htmlFor="sample-method">Method</FieldLabel>
          <Input
            id="sample-method"
            size="row"
            mono
            value={value.httpMethod}
            onChange={(event) => set({ httpMethod: event.target.value.toUpperCase() })}
          />
        </div>
        <div className="min-w-0 flex-1">
          <FieldLabel htmlFor="sample-path">Path</FieldLabel>
          <Input
            id="sample-path"
            size="row"
            mono
            placeholder="/in/src_…"
            value={value.path}
            onChange={(event) => set({ path: event.target.value })}
          />
        </div>
        <div className="min-w-0 flex-1">
          <FieldLabel htmlFor="sample-query">Query</FieldLabel>
          <Input
            id="sample-query"
            size="row"
            mono
            placeholder="a=1&b=2"
            value={value.query}
            onChange={(event) => set({ query: event.target.value })}
          />
        </div>
      </div>
    </div>
  );
};
